"use strict";
exports.__esModule = true;
exports.singleValueIterator = exports.iteratorSymbol = void 0;
exports.iteratorSymbol = (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
function singleValueIterator(getValue) {
    return function () {
        var done = false;
        var value = getValue(this);
        return {
            next: function () {
                if (done)
                    return { done: true };
                done = true;
                return { value: value, done: false };
            }
        };
    };
}
exports.singleValueIterator = singleValueIterator;
